import React from "react";
import "../pages/Login.css";

export default function Signup() {
  return (
    <div className="login-container">
      <div className="login-card">
        <div className="logo-container">
          <img 
            src="logo.png" 
            alt="Company Logo" 
            className="logo-image"
          />
        </div>
        <h2 className="login-title">eBadge Distribution</h2>
        <h3 className="register">Register</h3>
        <div className="input-group">
          <div className="input-wrapper">
            <span className="input-icon">👤</span>
            <input type="text" placeholder="Username" className="login-input" />
          </div>
          <div className="input-wrapper">
            <span className="input-icon">✉️</span>
            <input type="email" placeholder="Email" className="login-input" />
          </div>
          <div className="input-wrapper">
            <span className="input-icon">🔒</span>
            <input type="password" placeholder="Password" className="login-input" />
          </div>
          <button className="login-button">Register</button>
          <p className="register-text">
            Have an account? <a href="/login" className="register-link">Log in</a>
          </p>
        </div>
      </div>
    </div>
  );
}